import Avatar from 'components/Avatar'
import Flex from 'components/Flex'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import CallIcon from 'components/icons/CallIcon'
import MailIcon from 'components/icons/MailIcon'
import CurrentlyPursuingDetails from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/CurrentlyPursuingDetails'
import EducationSection from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/EducationSection'
import HonorsAwardsSection from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/HonorsAwardsSection'
import InfoSection from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/InfoSection'
import OtherDetails from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/OtherDetails'
import SocialMediaLinks from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/SocialMediaLinks'
import StudentDetailsAction from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/StudentDetailsAction'
import WorkExperienceSection from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/WorkExperienceSection'
import moment from 'moment'
import React, { Fragment } from 'react'
import { COLORS } from 'theme'

import {
  EditorContent,
  GreyText,
  Main,
  MainHeading,
  RewardTiteOther,
  SecondaryHeading,
  StyledDivider,
  StyledP,
  SubFLex,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import {
  CollegeName,
  DrawerHeader,
  HeaderFlexOne,
  InfoSectionNew,
  StudentName,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/style'
import {
  getDifferInMonthText,
  getMonthText,
  getYearText,
} from '../../../../../../../../utils/commonFunction'

const StudentDrawerContent = ({ singleStudentData, promotionData, flag,roleId }) => {
  const DateDiff = (start, end) => {
    const StartSplit = start?.split('/')
    const EndSplit = end ? end?.split('/') : new Date()
    const startDate = new Date(StartSplit[1], StartSplit[0], 1)
    const endDate = end ? new Date(EndSplit[1], EndSplit[0], 1) : new Date()
    const diffInMonths =
      (endDate.getFullYear() - startDate.getFullYear()) * 12 +
      (endDate.getMonth() - startDate.getMonth()) +
      1

    if (diffInMonths >= 12) {
      const years = Math.floor(diffInMonths / 12)
      const months = diffInMonths % 12
      return `${getYearText(years)} ${getMonthText(months)}`
    } else {
      return `${getDifferInMonthText(diffInMonths)}`
    }
  }

  const countRichTextCharacters = richText => {
    const plainText = richText?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')

    const characterCount = plainText?.length || 0 // Set to 0 if undefined

    return characterCount > 0 ? (
      <Fragment>
        <MainHeading marginBottom="15px">Career Objective</MainHeading>
        <StyledP
          dangerouslySetInnerHTML={{
            __html: singleStudentData?.resume?.objective,
          }}
        />
        <StyledDivider />
      </Fragment>
    ) : null
  }

  return (
    <>
      {flag && (
        <>
          <DrawerHeader centerVertically spaceBetween>
            <HeaderFlexOne spaceBetween>
              <Flex>
                <Avatar
                  background
                  src={singleStudentData?.profileUrl}
                  size={90}
                  IconName={singleStudentData?.firstName?.charAt('0')}
                  font={18}
                />
                <InfoSectionNew column center>
                  <StudentName>
                    {singleStudentData?.firstName}{' '}
                    {singleStudentData?.middelName}{' '}
                    {singleStudentData?.lastName}
                  </StudentName>
                  <CollegeName>
                    <MailIcon /> {singleStudentData?.admin?.email}
                  </CollegeName>
                  <CollegeName>
                    <CallIcon /> {singleStudentData?.admin?.country_code} -{' '}
                    {singleStudentData?.admin?.phone_number}
                  </CollegeName>
                </InfoSectionNew>
              </Flex>
            </HeaderFlexOne>
            <StudentDetailsAction singleStudentData={singleStudentData} roleId={roleId}/>
          </DrawerHeader>
          <StyledDivider />
        </>
      )}
      {!flag && (
        <div style={{ padding: '5px', borderTop: '1px solid #E6E7EA' }}></div>
      )}
      <Main>
        {singleStudentData?.resume?.objective
          ? countRichTextCharacters(singleStudentData?.resume?.objective)
          : null}

        {singleStudentData?.educationProfile?.length || singleStudentData?.currentCourse ? (
          <Fragment>
            <EducationSection studentData={singleStudentData} />

            {singleStudentData?.educationProfile?.map(
              item =>
                item?.awards?.length > 0 &&
                singleStudentData?.isExpCandidate && (
                  <>
                    <br></br>
                    <RewardTiteOther>Rewards and Recognition</RewardTiteOther>
                  </>
                )
            )}
            {singleStudentData?.educationProfile?.map(item =>
              item?.awards?.map((value, key) => (
                <SubFLex
                  column
                  gap="25px"
                  marginBottom="10px"
                  paddingLeft="60px"
                  key={key + value?.title}
                >
                  <SubFLex gap="12px">
                    <div>
                      <Avatar
                        background="none"
                        src={''}
                        size={48}
                        icon={<AwardsIconWork />}
                        boxShadow={true}
                        padding="5px"
                      />
                    </div>
                    <SubFLex column style={{ width: '90%' }}>
                      <SecondaryHeading>{value?.title}</SecondaryHeading>

                      <GreyText color={COLORS.GREY_T_60}>
                        {moment(value?.awarded_on).format('DD MMM YYYY')}
                      </GreyText>

                      <StyledP>
                        {' '}
                        <EditorContent
                          dangerouslySetInnerHTML={{
                            __html: value?.description || '',
                          }}
                        />{' '}
                      </StyledP>
                    </SubFLex>
                  </SubFLex>
                </SubFLex>
              ))
            )}

            <StyledDivider />
          </Fragment>
        ) : null}

        {singleStudentData?.resume?.internships?.length ? (
          <Fragment>
            <MainHeading>Internship</MainHeading>
            <SubFLex column gap="25px">
              {singleStudentData?.resume?.internships?.map((item, index) => (
                <InfoSection
                  key={index + item?.title}
                  name={item?.title}
                  company={item?.organization}
                  work={item?.description}
                  skills={item?.skill_set}
                  jobFunction={item?.function}
                  role={item?.role}
                  industry={item?.industry}
                  flag={true}
                  duration={(item?.started_in && item?.ended_in && item?.started_in !== '0' && item?.ended_in !== '0') ? `${moment(item?.started_in, 'MM/YYYY')?.format(
                    'MMM YYYY'
                  )} - ${moment(item?.ended_in, 'MM/YYYY')?.format(
                    'MMM YYYY'
                  )} (${DateDiff(item?.started_in, item?.ended_in)})` : ''}
                />
              ))}
            </SubFLex>

            {singleStudentData?.resume?.internships?.map(
              item =>
                item?.awards?.length > 0 &&
                singleStudentData?.isExpCandidate && (
                  <>
                    <br></br>
                    <RewardTiteOther>Rewards and Recognition</RewardTiteOther>
                  </>
                )
            )}
            {singleStudentData?.resume?.internships?.map(item =>
              item?.awards?.map((value, key) => (
                <SubFLex
                  column
                  gap="25px"
                  marginBottom="10px"
                  paddingLeft="60px"
                  key={key + 'internship'}
                >
                  <SubFLex gap="12px">
                    <div>
                      <Avatar
                        background="none"
                        src={''}
                        size={48}
                        icon={<AwardsIconWork />}
                        boxShadow={true}
                        padding="5px"
                      />
                    </div>
                    <SubFLex column style={{ width: '90%' }}>
                      <SecondaryHeading>{value?.title}</SecondaryHeading>
                      <GreyText color={COLORS.GREY_T_60}>
                        {moment(value?.awarded_on)?.format('DD MMM YYYY')}
                      </GreyText>
                      <StyledP>
                        <EditorContent
                          dangerouslySetInnerHTML={{
                            __html: value?.description || '',
                          }}
                        />
                      </StyledP>
                    </SubFLex>
                  </SubFLex>
                </SubFLex>
              ))
            )}

            <StyledDivider />
          </Fragment>
        ) : null}

        {singleStudentData?.resume?.projects?.length ? (
          <Fragment>
            <MainHeading>Project</MainHeading>
            <SubFLex column gap="25px">
              {singleStudentData?.resume?.projects?.map((item, index) => (
                <InfoSection
                  key={index + item?.title}
                  name={item?.title}
                  company={item?.organization}
                  work={item?.description}
                  skills={item?.skill_set}
                  jobFunction={item?.function}
                  role={item?.role}
                  industry={item?.industry}
                  flag={true}
                  duration={item?.started_in && item?.started_in !== '0' && item?.ended_in && item?.ended_in !== '0' 
                    ? `${getMonthText(item?.started_in)} ${getYearText(
                        item?.started_in
                      )} - ${getMonthText(item?.ended_in)} ${getYearText(
                        item?.ended_in
                      )} (${DateDiff(item?.started_in, item?.ended_in)})`
                    : ''
                  }
                />
              ))}
            </SubFLex>

            {singleStudentData?.resume?.projects?.map(
              item =>
                item?.awards?.length > 0 &&
                singleStudentData?.isExpCandidate && (
                  <>
                    <br></br>
                    <RewardTiteOther>Rewards and Recognition</RewardTiteOther>
                  </>
                )
            )}
            {singleStudentData?.resume?.projects?.map(item =>
              item?.awards?.map((value, key) => (
                <SubFLex
                  column
                  gap="25px"
                  marginBottom="10px"
                  paddingLeft="60px"
                  key={value + 'resume'}
                >
                  <SubFLex gap="12px">
                    <div>
                      <Avatar
                        background="none"
                        src={''}
                        size={48}
                        icon={<AwardsIconWork />}
                        boxShadow={true}
                        padding="5px"
                      />
                    </div>
                    <SubFLex column style={{ width: '90%' }}>
                      <SecondaryHeading>{value?.title}</SecondaryHeading>
                      <GreyText color={COLORS.GREY_T_60}>
                        {moment(value?.awarded_on)?.format('DD MMM YYYY')}
                      </GreyText>
                      <StyledP>
                        <EditorContent
                          dangerouslySetInnerHTML={{
                            __html: value?.description || '',
                          }}
                        />
                      </StyledP>
                    </SubFLex>
                  </SubFLex>
                </SubFLex>
              ))
            )}

            <StyledDivider />
          </Fragment>
        ) : null}

        {singleStudentData?.resume?.courses?.length ? (
          <Fragment>
            <MainHeading>Courses & Training</MainHeading>
            <SubFLex column gap="25px">
              {singleStudentData?.resume?.courses?.map((item, index) => (
                <InfoSection
                  key={index + item?.title}
                  name={item?.title}
                  company={item?.organization}
                  work={item?.description}
                  skills={item?.skill_set}
                  jobFunction={item?.function}
                  role={item?.role}
                  industry={item?.industry}
                  flag={false}
                  duration={(item?.started_in && item?.ended_in && item?.started_in !== '0' && item?.ended_in !== '0') ? `${moment(item?.started_in, 'MM/YYYY')?.format(
                    'MMM YYYY'
                  )} - ${moment(item?.ended_in, 'MM/YYYY')?.format(
                    'MMM YYYY'
                  )} (${DateDiff(item?.started_in, item?.ended_in)})` : ''}
                />
              ))}
            </SubFLex>
            {singleStudentData?.resume?.courses?.map(
              item =>
                item?.awards?.length > 0 &&
                singleStudentData?.isExpCandidate && (
                  <>
                    <br></br>
                    <RewardTiteOther>Rewards and Recognition</RewardTiteOther>
                  </>
                )
            )}
            {singleStudentData?.resume?.courses?.map(item =>
              item?.awards?.map((value, key) => (
                <SubFLex
                  column
                  gap="25px"
                  marginBottom="10px"
                  paddingLeft="60px"
                  key={key + value?.title}
                >
                  <SubFLex gap="12px">
                    <div>
                      <Avatar
                        background="none"
                        src={''}
                        size={48}
                        icon={<AwardsIconWork />}
                        boxShadow={true}
                        padding="5px"
                      />
                    </div>
                    <SubFLex column style={{ width: '90%' }}>
                      <SecondaryHeading>{value?.title}</SecondaryHeading>
                      <GreyText color={COLORS.GREY_T_60}>
                        {moment(value?.awarded_on)?.format('DD MMM YYYY')}
                      </GreyText>
                      <StyledP>
                        <EditorContent
                          dangerouslySetInnerHTML={{
                            __html: value?.description || '',
                          }}
                        />
                      </StyledP>
                    </SubFLex>
                  </SubFLex>
                </SubFLex>
              ))
            )}

            <StyledDivider />
          </Fragment>
        ) : null}

        {singleStudentData?.resume?.training?.length ? (
          <Fragment>
            <MainHeading>Training</MainHeading>
            <SubFLex column gap="25px">
              {singleStudentData?.resume?.training?.map((item, index) => (
                <InfoSection
                  key={index + item?.title}
                  name={item?.title}
                  company={item?.organization}
                  work={item?.description}
                  skills={item?.skill_set}
                  jobFunction={item?.function}
                  role={item?.role}
                  industry={item?.industry}
                  flag={false}
                  duration={(item?.started_in && item?.ended_in && item?.started_in !== '0' && item?.ended_in !== '0') ? `${moment(item?.started_in, 'MM/YYYY')?.format(
                    'MMM YYYY'
                  )} - ${moment(item?.ended_in, 'MM/YYYY')?.format(
                    'MMM YYYY'
                  )} (${DateDiff(item?.started_in, item?.ended_in)})` : ''}
                />
              ))}
            </SubFLex>

            <StyledDivider />
          </Fragment>
        ) : null}

        {singleStudentData?.resume?.workExperience?.length ? (
          <Fragment>
            <WorkExperienceSection 
              experience={singleStudentData?.resume?.workExperience} 
              resume={true}
              promotionData={promotionData} 
            />
            <StyledDivider />
          </Fragment>
        ) : null}

        {singleStudentData?.resume?.awards?.length ? (
          <Fragment>
            <MainHeading>Awards</MainHeading>
            {singleStudentData?.resume?.awards?.map((item, index) => (
              <HonorsAwardsSection
                key={index + item?.title}
                title={item?.title}
                organization={item?.organization}
                awarded_on={moment(item?.awarded_on, 'DD/MM/YYYY').format(
                  'DD MMM YYYY'
                )}
                description={item?.description}
              />
            ))}
            <StyledDivider />
          </Fragment>
        ) : null}
        {!singleStudentData?.isExpCandidate &&
        singleStudentData?.currentCourse?.educationLevel ? (
          <Fragment>
            {/* <CurrentlyPursuingDetails studentData={singleStudentData} /> */}
            {/* <StyledDivider /> */}
          </Fragment>
        ) : null}

        {singleStudentData?.studentPersonalProfile?.socialMedia?.length ? (
          <Fragment>
            <SocialMediaLinks
              socialMediaDetails={
                singleStudentData?.studentPersonalProfile?.socialMedia
              }
            />
            <StyledDivider />
          </Fragment>
        ) : null}

        <OtherDetails studentData={singleStudentData} />
      </Main>
    </>
  )
}

export default StudentDrawerContent
